import { Component } from '@angular/core';

import { Footer } from '../../components/footer/footer';
import { LiteHeroSection } from '../../components/lite-components/lite-hero-section/lite-hero-section';
import { LiteDetailSection } from '../../components/lite-components/lite-detail-section/lite-detail-section';
import { LiteFlowEvent } from '../../components/lite-components/lite-flow-event/lite-flow-event';
import { LiteTournamentSection } from '../../components/lite-components/lite-tournament-section/lite-tournament-section';
import { LiteFlowTournament } from '../../components/lite-components/lite-flow-tournament/lite-flow-tournament';
import { LiteGoodSection } from '../../components/lite-components/lite-good-section/lite-good-section';
import { LiteTestimonialSection } from '../../components/lite-components/lite-testimonial-section/lite-testimonial-section';
import { LiteInterestSection } from '../../components/lite-components/lite-interest-section/lite-interest-section';

@Component({
  selector: 'app-lite',
  imports: [
    Footer,
    LiteHeroSection,
    LiteDetailSection,
    LiteFlowEvent,
    LiteTournamentSection,
    LiteFlowTournament,
    LiteGoodSection,
    LiteTestimonialSection,
    LiteInterestSection,
  ],
  templateUrl: './lite.html',
  styleUrl: './lite.css',
})
export class Lite {}
